import dayjs from "dayjs";

function formatDate(date, format = "MM/DD/YYYY") {
  if (!date) return "";
  return dayjs(date).format(format);
}

export default formatDate;
